import React from 'react';
import PropTypes from 'prop-types';
import UploadPhoto from 'components/UploadPhoto';

const CrudUploadPhoto = ({ input, ...props }) => {
    const { onChange } = input;
    return <UploadPhoto onChange={onChange} value={input.value} {...props} />;
};

CrudUploadPhoto.propTypes = {
    input: PropTypes.shape({}).isRequired,
};

export default CrudUploadPhoto;
